/**
 * Check if a given object implements the PassTemplateManagementInfo interface.
 */
export function instanceOfPassTemplateManagementInfo(value) {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;
    return isInstance;
}
export function PassTemplateManagementInfoFromJSON(json) {
    return PassTemplateManagementInfoFromJSONTyped(json, false);
}
export function PassTemplateManagementInfoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'description': json['description'],
    };
}
export function PassTemplateManagementInfoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'description': value.description,
    };
}
